import { Box } from "@mui/material";
import InputText from "../../../components/InputText";
import SelectSimple from "../../../components/SelectSimple";
import { useGetFacilityIntegrNumberSelectElementsQuery } from "../../../../middleware/facilitiesApi";
import { SelectMultipleWithClientSearch } from "../../../components/SelectSimple/SelectMultipleWithClientSearch";
import { getSecurityFilterTable } from "../../../../helpers/tableHelper";
import { useAppSelector } from "../../../../hooks/redux";
import { useEffect, useState } from "react";
import { formatAddress } from "../../../../helpers/helper";

export const formFields = {
  name: "name",
  type: "type",
  protectionObjectIntegrNumberIds: "protectionObjectIntegrNumberIds",
};

export const typeOptions = [
  { value: 0, name: "Contact ID" },
  { value: 1, name: "Орион" },
  { value: 2, name: "Стрелец" },
];

const ObjectsSelectWithIntegrNumber = ({ ...props }) => {
  const { securityFilterTables } = useAppSelector((state) => state.settings);
  const [facilitiesOptions, setFacilitiesOptions] = useState([])
  const { data: facFireCompSelect = [] } = useGetFacilityIntegrNumberSelectElementsQuery({
    name: "",
    equipmentKindGroupId: getSecurityFilterTable(securityFilterTables),
    number: "",
    includeAddress: true,
  });

  useEffect(() => {
    if(!facFireCompSelect.length) return

    const formattedFacilitiesList = facFireCompSelect.map(item => {
      return {
        id: item.id,
        name: `${item.number}, ${item.facilityName}, ${formatAddress(item.address)}`,
      }
    })

    setFacilitiesOptions(formattedFacilitiesList)
  }, [facFireCompSelect])

  return <SelectMultipleWithClientSearch {...props} isIds={true} displayEmpty={false} options={facilitiesOptions} />;
};

export const config = [
  {
    name: formFields.name,
    label: "tableHeader:name",
    type: "text",
    required: true,
    input: (props) => (
      <Box sx={{ width: "300px" }}>
        <InputText {...props} />
      </Box>
    ),
  },
  {
    name: formFields.type,
    label: "label:controllerType",
    type: "select-number",
    options: typeOptions,
    defaultValue: "Contact ID",
    rules: {},
    input: (props) => (
      <Box sx={{ width: "300px" }}>
        <SelectSimple {...props} />
      </Box>
    ),
  },
  {
    name: formFields.protectionObjectIntegrNumberIds,
    type: "select-multi",
    label: "label:integrationNumbers",
    input: (props) => (
      <Box sx={{ width: "600px" }}>
        <ObjectsSelectWithIntegrNumber {...props} />
      </Box>
    ),
  },
];
